export const TOUR_STEP_IDS = {
  // Dashboard Tour IDs
  SIDEBAR_MENU: "sidebar-menu",
  HOME_BUTTON: "home-button",
  DASHBOARD_TITLE: "dashboard-title",
  REFRESH_BUTTON: "refresh-button",
  LIVE_CHAT_BUTTON: "live-chat-button",
  USER_PROFILE_BUTTON: "user-profile-button",
  
  // Policy Admin Tour IDs
  POLICY_ADMIN_PAGE: "policy-admin-page",
  REVIEW_ALL_POLICIES_BUTTON: "review-all-policies-button",
  ADD_PROCESS_BUTTON: "add-process-button",
  ADD_POLICY_BUTTON: "add-policy-button",
  OPEN_POLICY_BUTTON: "open-policy-button",
  DOWNLOAD_POLICY_BUTTON: "download-policy-button",
  HISTORY_BUTTON: "history-button",
  EDIT_POLICY_BUTTON: "edit-policy-button",
  COPY_EMBED_URL_BUTTON: "copy-embed-url-button",
  DELETE_POLICY_BUTTON: "delete-policy-button",
  TABLE_SORT_BUTTONS: "table-sort-buttons",
  TABLE_RESULTS_SELECTOR: "table-results-selector",
  TABLE_PAGE_SELECTOR: "table-page-selector",
  TABLE_MANAGE_COLUMNS: "table-manage-columns",
  FILTER_BAR: "filter-bar",
  SEARCH_BAR: "search-bar",

  // Compliance Calendar Tour IDs
  COMPLIANCE_CALENDAR_PAGE: "compliance-calendar-page",
  CALENDAR_NAVIGATION_BUTTONS: "calendar-navigation-buttons",
  ADD_TASK_BUTTON: "add-task-button",
  ADD_TO_CALENDAR_BUTTON: "add-to-calendar-button",
  ALL_EVENTS_FILTER: "all-events-filter",
  VIEW_SELECTOR: "view-selector",

  // Assurance Program Tour IDs
  ASSURANCE_PROGRAM_PAGE: "assurance-program-page",
  TASKS_SEARCH_BAR: "tasks-search-bar",
  TASKS_FILTER_BAR: "tasks-filter-bar",
  TASKS_SORTING_BUTTONS: "tasks-sorting-buttons",
  ADD_ASSURANCE_TASK_BUTTON: "add-assurance-task-button",
  TASKS_ACTION_BUTTONS: "tasks-action-buttons",
  TASKS_RESULTS_SELECTOR: "tasks-results-selector",
  TASKS_MANAGE_COLUMNS: "tasks-manage-columns",

  // Checklists Tour IDs
  CHECKLISTS_PAGE: "checklists-page",
  ADD_CHECKLIST_BUTTON: "add-checklist-button",
  CHECKLISTS_ACTION_BUTTONS: "checklists-action-buttons",
  CHECKLISTS_SORTING_BUTTONS: "checklists-sorting-buttons",

  // Audit Centre Tour IDs
  AUDIT_CENTRE_PAGE: "audit-centre-page",
  AUDITS_PAGE: "audits-page",
  CREATE_AUDIT_BUTTON: "create-audit-button",
  AUDITS_SORTING_BUTTONS: "audits-sorting-buttons",
  AUDITS_ACTION_BUTTONS: "audits-action-buttons",
  FINDINGS_PAGE: "findings-page",
  CREATE_FINDING_BUTTON: "create-finding-button",
  FINDINGS_SORTING_BUTTONS: "findings-sorting-buttons",
  FINDINGS_ACTION_BUTTONS: "findings-action-buttons",
  INCIDENTS_PAGE: "incidents-page",
  INCIDENTS_SORTING_BUTTONS: "incidents-sorting-buttons",
  INCIDENTS_ACTION_BUTTONS: "incidents-action-buttons",
  CORRECTIVE_ACTIONS_PAGE: "corrective-actions-page",
  CREATE_CORRECTIVE_ACTION_BUTTON: "create-corrective-action-button",
  CORRECTIVE_ACTIONS_SORTING_BUTTONS: "corrective-actions-sorting-buttons",
  CORRECTIVE_ACTIONS_ACTION_BUTTONS: "corrective-actions-action-buttons",

  // Settings Tour IDs
  SETTINGS_PAGE: "settings-page",
  SETTINGS_SIDEBAR: "settings-sidebar",
  ACCOUNT_SECTION: "account-section",
  THEME_SECTION: "theme-section",
  SECURITY_SECTION: "security-section",
  GENERAL_SECTION: "general-section",
  BILLING_SECTION: "billing-section",
  INTEGRATIONS_SECTION: "integrations-section",
  MODULES_SECTION: "modules-section",
  FEATURES_SECTION: "features-section",
  TRUST_PAGE_SECTION: "trust-page-section",
  PARTNERS_SECTION: "partners-section",
  MENUS_SECTION: "menus-section",
  CALENDAR_SECTION: "calendar-section",
  MSP_SETTINGS_SECTION: "msp-settings-section",
  DIAGNOSTICS_SECTION: "diagnostics-section",
  DEVELOPER_SECTION: "developer-section",

  // Registers Tour IDs
  REGISTERS_PAGE: "registers-page",
  ASSET_REGISTER_CARD: "asset-register-card",
  RISK_REGISTER_CARD: "risk-register-card",
  SUPPLIER_REGISTER_CARD: "supplier-register-card",
  PRIVACY_REGISTER_CARD: "privacy-register-card",
  DOCUMENT_REGISTER_CARD: "document-register-card",
  TASK_REGISTER_CARD: "task-register-card",

  // Asset Register Tour IDs
  ASSET_REGISTER_PAGE: "asset-register-page",
  ASSET_SEARCH_BAR: "asset-search-bar",
  ADD_ASSET_BUTTON: "add-asset-button",
  ASSET_SORTING_BUTTONS: "asset-sorting-buttons",
  ASSET_RESULTS_SELECTOR: "asset-results-selector",
  ASSET_MANAGE_COLUMNS: "asset-manage-columns",
  ASSET_ACTION_BUTTONS: "asset-action-buttons",

  // Data Privacy Requests Tour IDs
  PRIVACY_REQUESTS_PAGE: "privacy-requests-page",
  PRIVACY_REQUESTS_SEARCH_BAR: "privacy-requests-search-bar",
  ADD_PRIVACY_REQUEST_BUTTON: "add-privacy-request-button",
  PRIVACY_REQUESTS_FILTER_BUTTONS: "privacy-requests-filter-buttons",
  PRIVACY_REQUESTS_SORTING_BUTTONS: "privacy-requests-sorting-buttons",
  PRIVACY_REQUESTS_ACTION_BUTTONS: "privacy-requests-action-buttons",
  PRIVACY_REQUESTS_RESULTS_SELECTOR: "privacy-requests-results-selector",
  PRIVACY_REQUESTS_MANAGE_COLUMNS: "privacy-requests-manage-columns",

  // SOC 2 Control Matrix Tour IDs
  SOC2_CONTROL_MATRIX_PAGE: "soc2-control-matrix-page",
  SOC2_REFRESH_BUTTON: "soc2-refresh-button",
  SOC2_VIEW_ASSURANCE_BUTTON: "soc2-view-assurance-button",
  SOC2_OPEN_SOA_BUTTON: "soc2-open-soa-button",
  SOC2_SORTING_BUTTONS: "soc2-sorting-buttons",
  SOC2_RESULTS_SELECTOR: "soc2-results-selector",
  SOC2_MANAGE_COLUMNS: "soc2-manage-columns",

  // System Guide (MSG) Tour IDs
  SYSTEM_GUIDE_PAGE: "system-guide-page",
  MSG_SIDEBAR: "msg-sidebar",

  // Statement of Applicability (SOA) Tour IDs
  SOA_PAGE: "soa-page",
  SOA_EXPORT_BUTTON: "soa-export-button",
  SOA_REFRESH_BUTTON: "soa-refresh-button",
  SOA_OVERVIEW_CHART: "soa-overview-chart",
  SOA_SEARCH_BAR: "soa-search-bar",
  SOA_FILTER_BOXES: "soa-filter-boxes",
  SOA_SORTING_BUTTONS: "soa-sorting-buttons",
  SOA_TABLE_ACTION_BUTTONS: "soa-table-action-buttons",
  SOA_RESULTS_SELECTOR: "soa-results-selector",
  SOA_MANAGE_COLUMNS: "soa-manage-columns",

  // Document Library Tour IDs
  DOCUMENT_LIBRARY_PAGE: "document-library-page",
  DOC_FILTER_BUTTONS: "doc-filter-buttons",
  DOC_ADD_BUTTON: "doc-add-button",
  DOC_IMPORT_SHAREPOINT: "doc-import-sharepoint",
  DOC_SEARCH_BAR: "doc-search-bar",
  DOC_FILTER_BOXES: "doc-filter-boxes",
  DOC_SORTING_BUTTONS: "doc-sorting-buttons",
  DOC_TABLE_ACTION_BUTTONS: "doc-table-action-buttons",
  DOC_RESULTS_SELECTOR: "doc-results-selector",
  DOC_MANAGE_COLUMNS: "doc-manage-columns",

  // User Reports Tour IDs
  USER_REPORTS_PAGE: "user-reports-page",
  USER_REPORTS_SEARCH_BAR: "user-reports-search-bar",
  USER_REPORTS_FILTER: "user-reports-filter",
  USER_REPORTS_TABLE_ACTION: "user-reports-table-action",
  USER_REPORTS_ROWS_PER_PAGE: "user-reports-rows-per-page",
  USER_REPORTS_PAGE_NAV: "user-reports-page-nav",

  // User Management Tour IDs
  USER_MANAGEMENT_PAGE: "user-management-page",
  USER_MANAGEMENT_SEARCH_BAR: "user-management-search-bar",
  USER_MANAGEMENT_SHOW_ENTRA_TOGGLE: "user-management-show-entra-toggle",
  USER_MANAGEMENT_SYNC_BUTTON: "user-management-sync-button",
  USER_MANAGEMENT_ADD_USER: "user-management-add-user",
  USER_MANAGEMENT_TABLE_ACTIONS: "user-management-table-actions",
  USER_MANAGEMENT_RESULTS_SELECTOR: "user-management-results-selector",
  USER_MANAGEMENT_MANAGE_COLUMNS: "user-management-manage-columns",
};
